import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import API from '../api';
import { marked } from 'marked';
import DOMPurify from 'isomorphic-dompurify';
import { BillingCycle, BillingCycleContentKey } from '../common/interfaces';
import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
/**
 * fetches content based on query and environment
 * @param {string} query
 * @param {Environment} env
 * @param {ParsedUrlQuery} queryParams optional
 * @returns {Promise<any>} content
 */
export var getContent = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query, env, queryParams) {
    var content;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return API.getContent(query, env, queryParams);
        case 2:
          content = _context.sent;
          return _context.abrupt("return", content);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function getContent(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * parses markdown text and returns sanitized HTML
 * @param {string} text
 * @returns {PrasedText} object containing sanitized HTML
 */
export var parseMarkedDownText = function parseMarkedDownText(text) {
  return {
    __html: DOMPurify.sanitize(marked(text))
  };
};

/**
 * parses rich text and returns sanitized HTML
 * @param {any} content
 * @returns {ParsedText} object containing sanitized HTML
 */
export var parseRichText = function parseRichText(content) {
  return {
    __html: DOMPurify.sanitize(documentToHtmlString(content), {
      ALLOWED_TAGS: ['b', 'i', 'u', 'p', 'ul', 'ol', 'li', 'a']
    })
  };
};
var BILLING_CYCLE_CONTENT_KEY_MAP = _defineProperty(_defineProperty(_defineProperty({}, BillingCycle.MONTHLY, BillingCycleContentKey.MONTHLY), BillingCycle.SEMI_ANNUAL, BillingCycleContentKey.SEMI_ANNUAL), BillingCycle.ANNUAL, BillingCycleContentKey.ANNUAL);

/**
 * retrieves content key associated with the given billing cycle
 * @param {BillingCycle} billingCycle
 * @returns {BillingCycleContentKey}
 */
export var getBillingCycleContentKey = function getBillingCycleContentKey(billingCycle) {
  return BILLING_CYCLE_CONTENT_KEY_MAP[billingCycle];
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/ContentUtil.js
// module id = 379
// module chunks = 11